import * as React from "react"
const InfoCircleIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={18}
    height={19}
    fill="none"
    {...props}
  >
    <path
      fill="#A2A2A2"
      d="M9 18.5a9 9 0 1 1 9-9 9.01 9.01 0 0 1-9 9ZM9 2a7.5 7.5 0 1 0 7.5 7.5A7.509 7.509 0 0 0 9 2Z"
    />
    <path
      fill="#A2A2A2"
      d="M10.5 14.75H9V9.5H7.5V8H9a1.5 1.5 0 0 1 1.5 1.5v5.25ZM9 6.5a1.125 1.125 0 1 0 0-2.25A1.125 1.125 0 0 0 9 6.5Z"
    />
  </svg>
)
export default InfoCircleIcon